export const ATTRIBUTION_HINTS = {
  click: '点了广告链接之后，在所选天数内转化，算这条广告的。',
  engage: '没点链接，但点了广告其它地方，或视频播满 5 秒（不足 5 秒则看满 97%），1 天内转化算这条广告。选无就是不记互动。',
  view: '广告展示过后 1 天内转化算这条广告。选无就是只看过不算。',
};

export function attributionKey(spec) {
  if (!spec) return null;
  if (typeof spec === 'string') return spec;
  return spec.key || null;
}

export function hasSelectableDay(choices) {
  return (choices || []).some((item) => item.value !== 'none');
}

export function dayChoices(list, field) {
  const seen = new Set();
  const result = [];
  (list || []).forEach((item) => {
    const raw = item[field];
    const value = raw == null || raw === '' ? 'none' : raw;
    if (seen.has(value)) return;
    seen.add(value);
    result.push({ value, label: value === 'none' ? '无' : `${value}天` });
  });
  return result;
}

function normalizeDay(value) {
  if (value === 'none' || value === '' || value == null) return null;
  const number = Number(value);
  return Number.isNaN(number) ? null : number;
}

export function findAttributionKey(list, clickDays, engageDays, viewDays) {
  const click = normalizeDay(clickDays);
  const engage = normalizeDay(engageDays);
  const view = normalizeDay(viewDays);
  const hit = (list || []).find((item) => {
    return normalizeDay(item.clickDays) === click
      && normalizeDay(item.engageDays) === engage
      && normalizeDay(item.viewDays) === view;
  });
  return hit ? hit.key : null;
}

export function daysFromAttribution(list, spec) {
  const key = attributionKey(spec);
  const hit = (list || []).find((item) => item.key === key);
  if (!hit) {
    return { clickDays: null, engageDays: 'none', viewDays: 'none' };
  }
  return {
    clickDays: hit.clickDays == null ? 'none' : hit.clickDays,
    engageDays: hit.engageDays == null ? 'none' : hit.engageDays,
    viewDays: hit.viewDays == null ? 'none' : hit.viewDays,
  };
}
